import { Checkbox, Select } from "components/shared/form";
import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import React, { useState } from "react";
import { alert } from "services/alert";
import { getAllCarsList } from "sources/admin";
import { normalizeNumbers } from "sources/books/admin/organizations";

const getCarId = (car) => Number(car.id);

const formatFailedCars = (failedCarIds, cars) =>
    failedCarIds.map((id) => {
        const car = cars.find((item) => getCarId(item) === Number(id));

        return {
            id,
            number: car?.number || "",
        };
    });

const NormalizeCarNumbersForm = ({ organizationId, back }) => {
    const [data, setData] = useState({ carIds: null, normalizeAll: false });
    const [selectedCars, setSelectedCars] = useState([]);
    const [failedCars, setFailedCars] = useState([]);
    const [loading, setLoading] = useState(false);

    const setValue = ({ name, value, option }) => {
        setFailedCars([]);

        setData((prev) => ({
            ...prev,
            [name]: value,
            ...(name === "normalizeAll" && value ? { carIds: null } : {}),
        }));

        if (name === "carIds") {
            setSelectedCars(option || []);
        }

        if (name === "normalizeAll" && value) {
            setSelectedCars([]);
        }
    };

    const normalizeCarNumbers = () => {
        setLoading(true);
        setFailedCars([]);
        const carIds = data.normalizeAll ? null : data.carIds;

        normalizeNumbers({ organizationId, carIds })
            .then((res) => {
                if (!res) {
                    return setLoading(false);
                }

                const failedCarIds = res.failedCarIds || [];

                if (!failedCarIds.length) {
                    setLoading(false);
                    alert({
                        type: "success",
                        title: "Успешно!",
                        message: "Госномера машин нормализованы.",
                    });
                    back();
                    return null;
                }

                setFailedCars(formatFailedCars(failedCarIds, selectedCars));
                setLoading(false);
                return null;
            })
            .catch(() => setLoading(false));
    };

    const canNormalize = data.normalizeAll || data.carIds?.length > 0;

    return (
        <div className={loading ? "modal-window__form loading" : "modal-window__form"}>
            <Select
                {...defaultMultipleSelectProps}
                label="Машины"
                inputProps={{ name: "carIds" }}
                value={data.carIds}
                onChange={setValue}
                url={(params) => getAllCarsList(params, { organizationId })}
                propName="number"
                disabled={data.normalizeAll}
                menuPortalTarget={document.body}
                components={{ ValueContainer }}
            />
            <Checkbox
                fieldBeforeLabel
                labelWrapper="col-auto col-form-label col-form-label-sm pl-0"
                fieldWrapper="col-auto"
                bWrapper="row mb-2 align-items-center"
                label="Все машины организации"
                inputProps={{ name: "normalizeAll" }}
                value={data.normalizeAll}
                onChange={setValue}
            />
            {failedCars.length > 0 && (
                <div className="mb-3">
                    <div className="alert alert-warning font-size-14 mb-2">
                        Не удалось нормализовать следующие машины.
                    </div>
                    <table className="table table-sm mb-0">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Госномер</th>
                            </tr>
                        </thead>
                        <tbody>
                            {failedCars.map((car) => (
                                <tr key={car.id}>
                                    <td>{car.id}</td>
                                    <td>{car.number || "-"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <div className="modal-window__footer modal-window__footer--right">
                <button type="button" className="btn btn-secondary btn-sm mr-2" onClick={back}>
                    Отменить
                </button>
                <button
                    type="button"
                    className="btn btn-brand btn-sm"
                    onClick={normalizeCarNumbers}
                    disabled={loading || !canNormalize}
                >
                    Нормализовать
                </button>
            </div>
        </div>
    );
};

export default NormalizeCarNumbersForm;
